<template>
<div class='game pb-5 mb-5'>
  <StartTopBar v-if="!game || game && game.stage === 'waiting-for-players'"/>
  <GameTopBar v-if="game && game.stage !== 'waiting-for-players'"/>
  <div class="container-sm">

    <div v-if="!game || loading">
      <div class="row d-flex justify-content-center">
        <div v-if="true" class="spinner-border mt-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div v-if="game && !loading">
      <div v-if="game.stage === 'waiting-for-players'">
        <div class="row">
          <div class="col">
            <h6 class="">Waiting for players...</h6>
          </div>
        </div>

        <hr class="mb-4">
        
        <div v-if="game" class="row mb-2">
          <div class="col">
            <h6 class="font-weight-bold">Your friends waiting for you, faster share this link:</h6>
            <h6
              v-clipboard:copy="gameUrl"
              v-clipboard:success="onCopy"
              class="">
              {{ gameUrl }}
            </h6>
          </div>
        </div>

        <div v-if="game" class="row">
          <div class="col">
            <button 
              v-clipboard:copy="gameUrl"
              v-clipboard:success="onCopy"
              type="button"
              class="btn btn-danger rounded-lg px-5 mb-3">Copy link</button>
          </div>
        </div>

        <hr class="mb-4">

        <div v-if="game" class="row mb-4">
          <div class="col">
            <h6 class="font-weight-bold mb-3">Players joined ({{ game.players.length }}):</h6>
            <div v-for="(player, index) in game.players" :key="index">
              <div class="d-flex">
                <i class="material-icons">person</i>
                <h6 class="ml-2">{{ player.name }}</h6>
              </div>
            </div>
          </div>
        </div>

        <div v-if="admin && game.players.length >= 1 && game.stage == 'waiting-for-players'" class="row no-gutters d-flex mt-3">
          <div class="col-9">
            <h6>Points needed to win: <strong>{{ pointsTotal }}</strong></h6>
          </div>
          <div class="col-3">
            <i @click="adjustPointsTotal(-1)" class="material-icons pointer ml-4">remove_circle_outline</i>
            <i @click="adjustPointsTotal(1)" class="material-icons pointer ml-2">add_circle_outline</i>
          </div>
        </div>

        <div v-if="admin && game.players.length >= 1 && game.stage == 'waiting-for-players'" class="row no-gutters d-flex mt-1">
          <div class="col-9">
            <h6>No. of cards in hand: <strong>{{ handSize }}</strong></h6>
          </div>
          <div class="col-3">
            <i @click="adjustHandSize(-1)" class="material-icons pointer ml-4">remove_circle_outline</i>
            <i @click="adjustHandSize(1)" class="material-icons pointer ml-2">add_circle_outline</i>
          </div>
        </div>

        <div v-if="admin && game.players.length >= 1 && game.stage == 'waiting-for-players'" class="row no-gutters d-flex mt-1">
          <div class="col-9">
            <h6>No. of times players can change cards in hand: <strong>{{ maxHandChange }}</strong></h6>
          </div>
          <div class="col-3">
            <i @click="adjustMaxHandChange(-1)" class="material-icons pointer ml-4">remove_circle_outline</i>
            <i @click="adjustMaxHandChange(1)" class="material-icons pointer ml-2">add_circle_outline</i>
          </div>
        </div>
      </div>

      <!--  -->

      <div v-if="game.stage === 'bossing' && boss" class="mb-4">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5>It's your turn. You're the <strong class="text-danger">Laopeh!</strong></h5>
          </div>
          <div class="col-10 d-flex justify-content-center mb-2">
            <h6>Choose a card to play.</h6>
          </div>
        </div>
        <div class="row d-flex justify-content-center mb-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 22rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <button
          v-if="enableChangeRedCardButton"
          @click="skipARedCard"
          type="button"
          class="btn bg-white text-danger btn-outline-danger rounded-lg border-danger mt-1">Change card</button>
          <button
          v-if="!enableChangeRedCardButton"
          type="button"
          class="btn bg-white text-white btn-outline-white rounded-lg border-white mt-1 no-pointer" disabled>Change card</button>
        </div>
      </div>

      <!--  -->

      <div v-if="game.stage === 'bossing' && !boss">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Laopeh <strong class="text-danger">{{ game.boss }}</strong> is choosing a card. Please wait a bit...</h5>
          </div>
          <img style="max-width: 12rem;" src="@/assets/loadingboss.gif">
        </div>
      </div>

      <!--  -->

      <div v-if="game.stage === 'picking' && !boss && !isChosenWhiteCard" class="mb-4">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Laopeh <strong class="text-danger">{{ game.boss }}</strong> says:</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 22rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-4 mb-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 v-if="game.redCard.fill === 1" class="text-center">Pick {{ game.redCard.fill }} card:</h5>
            <h5 v-if="game.redCard.fill > 1" class="text-center">Pick {{ game.redCard.fill }} cards:</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-11">
            <div class="d-flex justify-content-center" v-for="(card, index) in hand" :key="index" @click="selectWhiteCard(index)">
              <label
              style="min-height: 1rem;"
              :class="'col-lg-6 col-lg-offset-3 mb-2 btn rounded rounded-lg ' + (chosenWhiteCards.indexOf(card) > -1 ? 'bg-danger text-white' : 'border-danger text-danger')"
              >
                <div class="card-body py-0">
                  <h5 v-if="chosenWhiteCards.indexOf(card) > -1 && game.redCard.fill > 1" class="card-title py-1 my-1">
                    <strong class="bg-white text-danger px-2 rounded mr-1">{{ chosenWhiteCards.indexOf(card) + 1 }}</strong> {{ card }}
                  </h5>
                  <h5 v-if="chosenWhiteCards.indexOf(card) === -1 || game.redCard.fill == 1" class="card-title py-1 my-1">
                    {{ card }}
                  </h5>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <button
          v-if="enableChangeHandButton && player.handChanges < game.maxHandChange"
          @click="changeTheHand"
          type="button"
          class="btn btn-danger rounded-lg border-0 mt-3">Change all cards in hand</button>
          <button
          v-if="!enableChangeHandButton || player.handChanges >= game.maxHandChange"
          type="button"
          class="btn btn-secondary rounded-lg mt-1 no-pointer mt-3" disabled>No more hand changes</button>
        </div>
        <div v-if="enableChangeHandButton && player.handChanges < game.maxHandChange">
          <h6 v-if="game.maxHandChange - player.handChanges === 1" class="text-center mt-2">You can only do this {{game.maxHandChange - player.handChanges}} more time.</h6>
          <h6 v-if="game.maxHandChange - player.handChanges > 1" class="text-center mt-2">You can only do this {{game.maxHandChange - player.handChanges}} more times.</h6>
        </div>
      </div>

      <div class="mb-4" v-if="game.stage === 'picking' && !boss && isChosenWhiteCard">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Waiting for players to choose their cards...</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 22rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!--  -->

      <div class="mb-4" v-if="game.stage === 'picking' && boss">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Waiting for players to choose their cards...</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 22rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!--  -->

      <div class="mb-4" v-if="game.stage === 'judging' && !boss">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Waiting for Laopeh <strong class="text-danger">{{ game.boss }}</strong> to select cards...</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-2">
          <img style="max-width: 5rem;" src="@/assets/loadingboss.gif">
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 8rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-4 mb-1">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Watch Laopeh view cards live:</h5>
          </div>
        </div>

        <div class="row d-flex justify-content-center mt-1">
          <div class="col-9 d-flex justify-content-center">
            <div class="card bg-white border-danger card-round" style="width: 16rem; min-height: 8rem;">
              <div class="card-body">
                  <h5
                  v-if="game.redCard.fill === 1"
                  v-for="(card, index) in game.currentWhiteCardsView"
                  :key="index"
                  class="card-title text-danger">{{ card }}</h5>
                  <h5
                  v-if="game.redCard.fill > 1"
                  v-for="(card, index) in game.currentWhiteCardsView"
                  :key="index"
                  class="card-title text-danger">[{{ index + 1 }}] {{ card }}</h5>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row d-flex justify-content-center">
          <div class="col-11">
            <div class="d-flex justify-content-center" v-for="(player, index0) in shuffledPlayers" :key="index0">
              <label
              style="min-height: 4rem;"
              class="col-lg-6 col-lg-offset-3 mb-2 btn rounded rounded-lg border-danger bg-white text-danger"
              >
                <div class="card-body py-1">
                  <h5
                  v-if="game.redCard.fill === 1"
                  v-for="(card, index1) in shuffledPlayers[index0].whiteCards"
                  :key="index1"
                  class="card-title py-1 my-1">{{ card }}</h5>
                  <h5
                  v-if="game.redCard.fill > 1"
                  v-for="(card, index1) in shuffledPlayers[index0].whiteCards"
                  :key="index1"
                  class="card-title py-1 my-1">[{{ index1 + 1 }}] {{ card }}</h5>
                </div>
              </label>
            </div>
          </div>
        </div> -->
      </div>

      <!--  -->

      <div v-if="game.stage === 'judging' && boss" class="mb-4">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Pick your favourite card.</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 8rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.redCard.text }}</h5>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-1">
          <div @click="adjustChosenWhiteCardIndex(-1)" class="col-1 d-flex align-items-center justify-content-center cursor pointer">
            <i class="material-icons">keyboard_arrow_left</i>
          </div>
          <div class="col-9 d-flex justify-content-center">
            <div class="card bg-white border-danger card-round" style="width: 16rem; min-height: 8rem;">
              <div class="card-body">
                  <h5
                  v-if="game.redCard.fill === 1"
                  v-for="(card, index1) in game.shuffledPlayers[chosenWhiteCardIndex].whiteCards"
                  :key="index1"
                  class="card-title text-danger">{{ card }}</h5>
                  <h5
                  v-if="game.redCard.fill > 1"
                  v-for="(card, index1) in game.shuffledPlayers[chosenWhiteCardIndex].whiteCards"
                  :key="index1"
                  class="card-title text-danger">[{{ index1 + 1 }}] {{ card }}</h5>
              </div>
            </div>
          </div>
          <div @click="adjustChosenWhiteCardIndex(1)" class="col-1 d-flex align-items-center justify-content-center pointer">
            <i class="material-icons">keyboard_arrow_right</i>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">{{ chosenWhiteCardIndex + 1 }} / {{ game.shuffledPlayers.length }}</h5>
          </div>
        </div>
      </div>

      <!--  -->

      <div class="mb-4" v-if="game.stage === 'revelation'">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Laopeh <strong class="text-danger">{{ game.previousBoss }}</strong> picked <strong class="text-danger">{{ game.currentWinner }}</strong>'s card!</h5>
          </div>
          <img style="max-width: 9rem;" src="@/assets/celebration.gif">
        </div>
        <div class="row d-flex justify-content-center mt-3">
          <div class="card bg-danger border-0 card-round" style="width: 16rem; min-height: 8rem;">
            <div class="card-body">
              <h5 class="card-title text-white">{{ game.previousRedCard.text }}</h5>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-1">
          <div class="card bg-white border-danger card-round" style="width: 16rem; min-height: 8rem;">
            <div class="card-body" @click="judgeWhiteCard(index0)">
              <h5
              v-if="game.chosenWhiteCards.length === 1"
              v-for="(card, index) in game.chosenWhiteCards"
              :key="index"
              class="card-title text-danger">{{ card }}</h5>
              <h5
              v-if="game.chosenWhiteCards.length > 1"
              v-for="(card, index) in game.chosenWhiteCards"
              :key="index"
              class="card-title text-danger">[{{ index + 1 }}] {{ card }}</h5>
            </div>
          </div>
        </div>
      </div>

      <!--  -->

      <div v-if="game.stage === 'handpicking-normal'">
        <div class="row d-flex justify-content-center mt-2">
          <div class="col-10 d-flex justify-content-center">
            <h5 class="text-center">Winner: {{ game.champion }}!</h5>
          </div>
        </div>
        <div class="row d-flex justify-content-center mt-1">
          <img style="max-width: 12rem;" src="@/assets/champion.png">
        </div>
      </div>

      <!--  -->

      <hr class="mb-4" v-if="game && ['bossing', 'picking', 'judging', 'revelation', 'concluded'].includes(game.stage)"/>
      
      <div v-if="game && ['bossing', 'picking', 'judging', 'revelation', 'concluded'].includes(game.stage)" class="row">
        <div class="col">
          <h6 class="font-weight-bold mb-3">Scoreboard:</h6>
          <div v-for="(player, index) in sortedPlayers" :key="index">
            <div class="row">
              <div v-if="player.whiteCards.length > 0 || player.name === game.boss" class="col-1">
                <i class="material-icons">how_to_reg</i>
              </div>
              <div v-if="player.whiteCards.length === 0 && player.name !== game.boss" class="col-1">
                <i class="material-icons">person</i>
              </div>
              <div class="col-3">
                <h6>{{ player.name }}</h6>
              </div>
              <div class="col-6">
                <h6> {{ player.points }} points</h6>
              </div>
              <!-- <div class="col-1">
                <i class="material-icons">close</i>
              </div> -->
            </div>
          </div>
          <h6 v-if="game" class="mt-2 mb-4">First player to reach {{ game.pointsTotal }} points wins!</h6>
        </div>
      </div>

    </div>
  </div>
  <div v-if="admin && game && game.stage === 'waiting-for-players'">
    <button v-if="game.players.length < 2" type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Start Game (need more players)
    </button>
    <button v-if="game.players.length > 1" @click="startAGame" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Start Game
    </button>
  </div>
  <div v-if="!admin && game && game.stage === 'waiting-for-players'">
    <button type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Wait for admin to start game
    </button>
  </div>
  <div v-if="game && game.stage === 'bossing' && boss">
    <button @click="selectARedCard" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Play card
    </button>
  </div>
  <div v-if="game && game.stage === 'bossing' && !boss">
    <button type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Wait for Laopeh to choose card
    </button>
  </div>
  <div v-if="game && game.stage === 'picking' && !boss">
    <button v-if="game.redCard.fill > chosenWhiteCards.length" type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Play card
    </button>
    <button v-if="game.redCard.fill === chosenWhiteCards.length" @click="playTheWhiteCards" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Play card
    </button>
  </div>
  <div v-if="game && game.stage === 'picking' && boss">
    <button type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Wait for players to choose cards
    </button>
  </div>
  <div v-if="game && game.stage === 'judging' && !boss">
    <button type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Wait for Laopeh
    </button>
  </div>
  <div v-if="game && game.stage === 'judging' && boss">
    <button @click="selectJudgedWhiteCard" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Select card
    </button>
  </div>
  <div v-if="game && game.stage === 'revelation' && admin">
    <button @click="startNextRound" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Start next round
    </button>
  </div>
  <div v-if="game && game.stage === 'revelation' && !admin">
    <button type="button" class="btn btn-secondary btn-lg btn-block fixed-bottom rounded-0 py-3">
      Wait for admin to start round
    </button>
  </div>
  <div v-if="game && game.stage === 'concluded' && admin">
    <button @click="startNextGame" type="button" class="btn btn-danger btn-lg btn-block fixed-bottom rounded-0 py-3">
      Start new game
    </button>
  </div>
  <!-- <Footer/> -->
</div>
</template>

<script>
import firebaseApp from '@/firebase/init'
import StartTopBar from '@/components/StartTopBar'
import GameTopBar from '@/components/GameTopBar'
import Footer from '@/components/Footer'

export default {
  name: 'Game',
  components: {
    StartTopBar,
    GameTopBar,
    Footer,
  },
  data() {
    return {
      playerCode: this.$route.params.playerCode,
      gameCode: this.$route.params.gameCode,
      game: null,
      pointsTotal: 10,
      handSize: 10,
      chosenWhiteCards: [],
      played: false,
      enableChangeRedCardButton: true,
      enableChangeHandButton: true,
      celebration: false,
      isChosenWhiteCard: false,
      chosenWhiteCardIndex: 0,
      maxHandChange: 0,
      filter: true,
      loading: false
    }
  },
  computed: {
    gameUrl: function(){
      return `https://laopehsays.com/join-game/${this.gameCode}`
    },
    player: function(){
      if(this.game) {
        let toReturn = null
        this.game.players.forEach(player => {
          if(this.playerCode === player.code){
            toReturn = player
          }
        })
        return toReturn
      } else {
        return null
      }
    },
    playerName: function(){
      console.log('there')
      if(this.game) {
        let playerName = null
        this.game.players.forEach(player => {
          console.log('here')
          if(this.playerCode === player.code){
            playerName = player.name
          }
        })
        return playerName
      } else {
        return null
      }
    },
    admin: function(){
      if(this.game) {
        return this.playerName === this.game.adminPlayerName
      }
    },
    hand: function(){
      if(this.game) {
        let hand = null
        this.game.players.forEach(player => {
          if(this.playerCode === player.code){
            hand = player.hand;
          }
        })
        return hand;
      } else {
        return null;
      }
    },
    boss: function(){
      if(this.game) {
        return this.playerName === this.game.boss
      }
    },
    sortedPlayers: function() {
      function removeDuplicatesBy(keyFn, array) {
        var mySet = new Set();
        return array.filter(function(x) {
          var key = keyFn(x), isNew = !mySet.has(key);
          if (isNew) mySet.add(key);
          return isNew;
        });
      }
      if(this.game) {
        return removeDuplicatesBy(x => x.code,
          this.game.players.sort((a,b) => {
            if ( a.code < b.code ){
              return -1;
            }
            if ( a.code > b.code ){
              return 1;
            }
            return 0;
          })  
        )
      }
    }
  },
  watch: {
    game: function(newGame, oldGame){
      let isChosenWhiteCard = false
      if(this.game) {
        this.game.players.forEach(player => {
          if(this.playerCode === player.code){
            if(player.whiteCards.length){
              isChosenWhiteCard = true
            }
          }
        })
      }
      this.isChosenWhiteCard = isChosenWhiteCard
    }
  },
  methods: {
    startAGame() {
      this.loading = true
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'startGame',
        gameCode: this.gameCode,
        pointsTotal: this.pointsTotal,
        handSize: this.handSize,
        maxHandChange: this.maxHandChange
      }).then(result => {
        this.game.round = 'bossing';
        this.loading = false
      });
    },
    onCopy() {
      alert('Help you copy already, just paste to your friends now.');
    },
    selectARedCard() {
      this.game.stage = 'picking'
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'selectRedCard',
        gameCode: this.gameCode,
        redCard: this.game.redCard
      }).then(result => {
        // this.loading = true;
      });
    },
    selectWhiteCard(index) {
      if(this.chosenWhiteCards.includes(this.hand[index])){
        this.chosenWhiteCards.splice(
          this.chosenWhiteCards.indexOf(this.hand[index]), 1
        );
      } else if (this.game.redCard.fill > this.chosenWhiteCards.length){
        this.chosenWhiteCards.push(
          this.hand[index]
        )
      } else {
        this.chosenWhiteCards = [this.hand[index]]
      }
    },
    selectJudgedWhiteCard() {
      this.game.stage = 'revelation'
      this.game.previousBoss = this.game.boss
      this.game.previousRedCard = this.game.redCard
      this.game.chosenWhiteCards = this.game.shuffledPlayers[this.chosenWhiteCardIndex].whiteCards
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'chooseWhiteCards',
        gameCode: this.gameCode,
        whiteCards: this.game.shuffledPlayers[this.chosenWhiteCardIndex].whiteCards,
      }).then(result => {
        // this.loading = true;
      });
    },
    skipARedCard() {
      this.enableChangeRedCardButton = false
      this.game.redCard = this.game.redCards.pop()
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'skipRedCard',
        gameCode: this.gameCode,
        redCard: this.game.redCard,
        redCards: this.game.redCards
      }).then(result => {
        this.game.redCard = result
        this.enableChangeRedCardButton = true
      });
    },
    changeTheHand() {
      this.enableChangeHandButton = false
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'changeHand',
        gameCode: this.gameCode,
        playerCode: this.playerCode
      }).then(result => {
        this.enableChangeHandButton = true
      });
    },
    playTheWhiteCards() {
      this.isChosenWhiteCard = true
      this.game.players.forEach((player, index) => {
        if(this.playerCode === player.code){
          this.game.players[index].whiteCards = this.chosenWhiteCards
        }
      })
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'playWhiteCards',
        gameCode: this.gameCode,
        playerCode: this.playerCode,
        whiteCards: this.chosenWhiteCards
      }).then(result => {
        // this.loading = true;
      })
      this.chosenWhiteCards = []
    },
    adjustPointsTotal(value) {
      if(this.pointsTotal > 1 || value > 0) {
        this.pointsTotal += value
      }
    },
    adjustHandSize(value) {
      if(this.handSize > 2 || value > 0) {
        this.handSize += value
      }
    },
    adjustMaxHandChange(value) {
      if(this.maxHandChange > 0 || value > 0) {
        this.maxHandChange += value
      }
    },
    adjustChosenWhiteCardIndex(value) {
      if(this.chosenWhiteCardIndex + value < 0){
        this.chosenWhiteCardIndex = this.game.shuffledPlayers.length - 1
      } else if (this.chosenWhiteCardIndex + value > this.game.shuffledPlayers.length - 1){
        this.chosenWhiteCardIndex = 0
      } else {
        this.chosenWhiteCardIndex += value
      }

      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'changeViewWhiteCards',
        gameCode: this.gameCode,
        whiteCards: this.game.shuffledPlayers[this.chosenWhiteCardIndex].whiteCards
      }).then(result => {
        // this.loading = true;
      })
    },
    closeCelebration(value) {
      this.celebration = false
    },
    startNextRound() {
      this.game.stage = 'bossing'
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'nextRound',
        gameCode: this.gameCode,
      }).then(result => {
        // this.loading = true;
      })
    },
    startNextGame() {
      this.game.stage = 'waiting-for-players'
      const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
      masterFunction({
        methodName: 'nextGame',
        gameCode: this.gameCode,
      }).then(result => {
        // this.loading = true;
      })
    }
  },
  created() {
    if(this.playerCode && this.gameCode) {
      const gameRef = firebaseApp.firestore()
      .collection('games')
      .where('gameCode', '==', this.gameCode)
      gameRef.onSnapshot(snapshot => {
        snapshot.forEach(doc => {
          this.game = {
            id: doc.id,
            ...doc.data(),
          }
        })
      })
    } else {
      this.$router.push({ name: 'CreateGame' })
    }
  }
}
</script>

<style>

h3{
  font-size: 2em;
}
h4{
  font-size: 1.6em;
  margin-top: 2px;
  margin-bottom: 2px;
}
.card {
  display:inline-block;
}
.white-card {
  cursor: pointer !important;
}
.pointer {
  cursor: pointer !important;
}
.no-pointer {
  cursor: default  !important;
}
.card-round {
  border-radius: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Game.vue